export default __webpack_public_path__ + "static/media/menuIcon.36a38b24.svg";